import { render } from "./MbTicketNameDisp.vue?vue&type=template&id=5c27f964&scoped=true"
import script from "./MbTicketNameDisp.vue?vue&type=script&lang=js"
export * from "./MbTicketNameDisp.vue?vue&type=script&lang=js"

import "./MbTicketNameDisp.vue?vue&type=style&index=0&id=5c27f964&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c27f964"

export default script